import s from './News.module.scss';
import Image from "next/image";
import {TNewsCardProps} from "@/app/[locale]/common/components/News/types";
import {Link} from '@/i18n/routing';
import {BUTTON_TEXTS} from "../../constants/button";
import {textAbbreviation} from "@/app/[locale]/common/utils/functions/textAbbreviation/textAbbreviation";
import {convertDateFormat} from "@/app/[locale]/common/utils/functions/convertDateFormat/convertDateFormat";

export const NewsMinorCard = ({ id, title, text, date, image}: TNewsCardProps) => {
    const formatedText = textAbbreviation(text, 71);
    const formatedDate = convertDateFormat(date);

    return (
        <div className={s.minor}>
            <div className={s.minor_content}>
                <label>{title}</label>
                <span className={s.minor_date}>{formatedDate}</span>
                <div className={s.minor_text}>
                    <p>
                        {formatedText}
                        <span>
                        <Link key={date} href={`/news/${id as string}`} className={s.minor_text_link}>
                            {BUTTON_TEXTS.INFO_READ_MORE}
                        </Link>
                    </span>
                    </p>
                </div>
            </div>
            <Link href={`/news/${id as string}`} className={s.minor_imageContainer}>
                <Image src={image} alt={''} width={100} height={100} />
            </Link>
        </div>
    );
};